
import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertFromRaw,
  convertToRaw
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useStyles from "../styles";

const WysiwygEditor = (props) => {
  const { value, onChange, error, required, placeholder, isNewV1Theme} = props;
  const classes = useStyles();

  const parseRawContent = (val) => {
    if (!val) return null;

    if (typeof val === "string") {
      try {
        const parsed = JSON.parse(val);
        if (parsed?.blocks && Array.isArray(parsed.blocks)) {
          return parsed;
        }
      } catch (e) {
        console.warn("Invalid JSON for DraftJS:", e);
      }
      // Fallback for both parse failure or missing blocks
      return createPlainTextRaw(val);
    }
  
    // If already an object, assume it's valid
    return val;
  };
  
  const createPlainTextRaw = (text) => ({
    blocks: [
      {
        key: Math.random().toString(36).substring(2, 8),
        text,
        type: "unstyled",
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
    entityMap: {},
  });
  
  // Initialize editor state from value
  const getInitialEditorState = (val) => {
    const parsed = parseRawContent(val);
    if (parsed?.blocks && Array.isArray(parsed.blocks)) {
      const content = convertFromRaw({
        blocks: parsed.blocks,
        entityMap: parsed.entityMap || {},
      });
      return EditorState.createWithContent(content);
    }
    return EditorState.createEmpty();
  };

  const [editorState, setEditorState] = useState(getInitialEditorState(value));

  // Sync editor state when value prop changes  
  useEffect(() => {
    const newEditorState = getInitialEditorState(value);
    const currentRaw = convertToRaw(editorState.getCurrentContent());
    const newRaw = convertToRaw(newEditorState.getCurrentContent());

    if (JSON.stringify(currentRaw) !== JSON.stringify(newRaw)) {
      setEditorState(newEditorState);
    }
  }, [value]);

  // Update local state when editor changes
  const handleEditorChange = (state) => {
    setEditorState(state);
  };


  // Fire onBlur to send content back to parent
  const handleBlur = () => {
    const content = editorState.getCurrentContent();
    const hasContent = content.hasText();
    onChange(hasContent ? JSON.stringify(convertToRaw(content)) : "");
  };

  return (
    <div
      className={isNewV1Theme ? `${classes.wysiwygEditor} ${classes.wysiwygEditorNewTheme}` : ''}
      style={{
        border: !isNewV1Theme && (error ? "1px solid red" : "1px solid #ccc"),
        borderRadius: "4px",
      }}
    >
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        editorStyle={{
          minHeight: "200px",
          padding: "10px",
          border: isNewV1Theme && (error ? "1px solid red" : "1px solid #E9EBF5"),
          borderTop: isNewV1Theme && "none",
        }}
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "fontFamily",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "emoji",
            "image",
            "remove",
            "history",
          ],
          inline: {
            options: ["bold", "italic", "underline", "strikethrough"],
          },
        }}
      />
      {error && required && (
        <div
          style={{
            color: "red",
            fontSize: "0.8rem",
            marginTop: 5,
          }}
        >
          This field is required
        </div>
      )}
    </div>
  );
};

export default WysiwygEditor;

